// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d7b0b4a7","answerTime":"c5cbcac0","iconClock":"da10a54e","helpText":"cf4d4a66"};